export const manufacturingTr = {
  title: 'Üretim emirleri',
  subtitle:
    'Onaylı reçeteleri planlayın, lot bazında tüketin ve eksiksiz denetim iziyle tamamlayın.',
  help: {
    open: 'Üretim emri yardımını aç',
    detail: 'Planlama, kayıtlar ve tamamlama yardımını aç',
  },
  actions: {
    new: 'Yeni emir',
    plan: 'Planla',
    release: 'Serbest bırak',
    reserve: 'Malzeme ayır',
    start: 'Başlat',
    pause: 'Duraklat',
    resume: 'Devam et',
    reportComplete: 'Tamamlandı bildir',
    close: 'Kapat',
    cancel: 'İptal et',
    issue: 'Çıkış yap',
    return: 'İade et',
    confirmStep: 'Bildir',
    comment: 'Yorum',
    post: 'Kaydet',
  },
  filters: {
    search: 'Numara, ürün veya ihtiyaç ara',
    status: 'Durum',
    allStatuses: 'Tüm durumlar',
    priority: 'Öncelik',
    allPriorities: 'Tüm öncelikler',
    from: 'Başlangıç tarihi',
    to: 'Bitiş tarihi',
  },
  statuses: {
    DRAFT: 'Taslak',
    PLANNED: 'Planlandı',
    RELEASED: 'Serbest',
    MATERIAL_RESERVED: 'Malzeme ayrıldı',
    IN_PRODUCTION: 'Üretimde',
    PAUSED: 'Duraklatıldı',
    REPORTED_COMPLETE: 'Tamamlandı bildirildi',
    CLOSED: 'Kapandı',
    CANCELLED: 'İptal edildi',
  },
  priorities: { LOW: 'Düşük', NORMAL: 'Normal', HIGH: 'Yüksek', URGENT: 'Acil' },
  columns: {
    number: 'Emir',
    product: 'Nihai ürün',
    status: 'Durum',
    priority: 'Öncelik',
    recipe: 'Reçete',
    planned: 'Plan',
    produced: 'Üretilen',
    start: 'Başlangıç',
    updated: 'Değişiklik',
    position: 'Sıra',
    material: 'Malzeme',
    reserved: 'Ayrılan',
    issued: 'Çıkışı yapılan',
    returned: 'İade',
    scrap: 'Fire',
    variance: 'Sapma',
    step: 'Operasyon',
    workCenter: 'İş merkezi',
    duration: 'Süre (dk)',
    input: 'Girdi',
    output: 'Çıktı',
    type: 'Tür',
    batch: 'Lot',
    quantity: 'Miktar',
  },
  empty: 'Üretim emri bulunamadı.',
  editor: {
    newTitle: 'Üretim emri oluştur',
    subtitle: 'Sunucu tarafı ölçekleme, onaylı reçete ve rotadan ihtiyaçları hesaplar.',
    plan: 'Planlama temeli',
    planDescription:
      'Kaynak, miktar, tarihler, depolar ve sorumluları belirleyin. Taslaklar iyimser kilit kullanır.',
  },
  fields: {
    recipe: 'Onaylı reçete',
    routing: 'Onaylı rota',
    plannedQuantity: 'Planlanan miktar',
    unit: 'Birim',
    priority: 'Öncelik',
    salesOrder: 'Satış siparişi',
    plannedStart: 'Planlanan başlangıç',
    plannedEnd: 'Planlanan bitiş',
    sourceWarehouse: 'Çıkış deposu',
    targetWarehouse: 'Hedef depo',
    internalDemand: 'İç ihtiyaç',
    responsibleUsers: 'Sorumlu kişiler',
    note: 'Not / gerekçe',
    postingType: 'Kayıt türü',
    quantity: 'Miktar',
    reason: 'Gerekçe',
    stepResult: 'Sonuç',
    inputQuantity: 'Girdi miktarı',
    outputQuantity: 'Çıktı miktarı',
    scrapQuantity: 'Fire miktarı',
    duration: 'Gerçek süre (dk)',
    qualityChecks: 'Zorunlu kalite kontrolleri',
    producedQuantity: 'Üretilen miktar',
    batchNumber: 'Yeni lot numarası',
    bestBefore: 'Tavsiye edilen tüketim tarihi',
  },
  shortage: {
    title: 'Malzeme açığı',
    description: '{{count}} malzeme kalemi mevcut serbest stokla tamamen karşılanamıyor.',
  },
  tabs: {
    materials: 'Malzeme ve tüketim',
    process: 'Süreç ve kalite',
    outputs: 'Çıktılar',
    history: 'Geçmiş ve yorumlar',
    documents: 'DYS belgeleri',
  },
  documents: { title: 'Üretim dosyası' },
  summary: {
    planned: 'Planlanan miktar',
    produced: 'Üretilen',
    scrap: 'Fire',
    yield: 'Gerçek verim',
    plannedCost: 'Planlanan malzeme maliyeti',
    actualCost: 'Gerçek malzeme maliyeti',
  },
  materials: {
    title: 'Malzeme kalemleri',
    description:
      'İhtiyaç, rezervasyon ve lot bazlı kayıtlar ayrı tutulur ve kesin ondalık değerler kullanır.',
  },
  process: {
    title: 'Süreç bildirimleri',
    description:
      'Operasyonlar, parametreler ve kalite kontrolleri onaylı planlama anlık görüntüsünden gelir.',
  },
  stepStatuses: {
    PENDING: 'Bekliyor',
    IN_PROGRESS: 'Devam ediyor',
    COMPLETED: 'Tamamlandı',
    SKIPPED: 'Gerekçeyle atlandı',
  },
  outputs: {
    title: 'Çıktılar ve üretilen lotlar',
    description: 'Tamamlama kaydındaki nihai ürün, yan ürün ve fireler.',
    empty: 'Henüz çıktı kaydedilmedi.',
  },
  outputTypes: { FINISHED_GOOD: 'Nihai ürün', BYPRODUCT: 'Yan ürün', SCRAP: 'Fire' },
  history: {
    title: 'Değiştirilemez kayıt geçmişi',
    description: 'Her işlem idempotans anahtarı, yük özeti, kullanıcı ve zaman damgası içerir.',
  },
  comments: {
    title: 'Yorumlar',
    description: 'Denetlenen üretim dosyasındaki yalnızca eklenebilir notlar.',
    empty: 'Henüz yorum yok.',
  },
  operationTypes: {
    CREATE: 'Oluşturuldu',
    UPDATE: 'Taslak güncellendi',
    PLAN: 'Planlandı',
    RELEASE: 'Serbest bırakıldı',
    RESERVE: 'Ayrıldı',
    ISSUE: 'Malzeme çıkışı',
    RETURN: 'Malzeme iadesi',
    START: 'Başlatıldı',
    PAUSE: 'Duraklatıldı',
    RESUME: 'Devam ettirildi',
    STEP_CONFIRM: 'Adım bildirildi',
    REPORT_COMPLETE: 'Tamamlandı bildirildi',
    CLOSE: 'Kapatıldı',
    CANCEL: 'İptal edildi',
    COMMENT: 'Yorum eklendi',
  },
  workflow: {
    plan: {
      title: 'Emri planla',
      description: 'Planlama anlık görüntüsü dondurulur; sonrasında yapısal değişiklik yapılamaz.',
    },
    release: {
      title: 'Emri serbest bırak',
      description: 'Onaylı kaynaklar ve planlanan ihtiyaçlar bağlayıcı kayıt temeli olur.',
    },
    start: {
      title: 'Üretimi başlat',
      description: 'Gerçek başlangıç kaydedilir ve lot bazlı çıkışlar izlenebilir kalır.',
    },
    pause: {
      title: 'Üretimi duraklat',
      description: 'Emir kayıt kabul etmeye devam eder ancak duraklatılmış görünür.',
    },
    resume: { title: 'Üretime devam et', description: 'Emir yeniden aktif üretime geçer.' },
    close: {
      title: 'Emri kapat',
      description: 'Açık rezervasyonlar serbest bırakılır ve kapalı emir değiştirilemez olur.',
    },
  },
  reserve: {
    title: 'Serbest stoğu otomatik ayır',
    description: 'Seçim FEFO/FIFO stratejisine göre işlemsel yapılır; açıklar görünür kalır.',
  },
  materialDialog: {
    ISSUE: { title: 'Malzeme çıkışı kaydet' },
    SCRAP: { title: 'Malzeme firesi kaydet' },
    RETURN: { title: 'Malzeme iadesi kaydet' },
  },
  materialActions: { ISSUE: 'Çıkış', SCRAP: 'Fire', RETURN: 'İade' },
  quality: { PASS: 'Geçti', FAIL: 'Başarısız', NOT_CHECKED: 'Kontrol edilmedi' },
  stepDialog: { title: 'Süreç adımını bildir' },
  report: {
    title: 'Üretimi tamamlandı bildir',
    description: 'Nihai ürün lotu ve stok girişleri tek işlemde birlikte oluşturulur.',
  },
  cancel: {
    title: 'Üretim emrini iptal et',
    description: 'Gerekçe zorunludur ve kalan gerçek tüketim önce iade edilmelidir.',
  },
  comment: {
    title: 'Yorum ekle',
    description: 'Kayıt kullanıcı ve zaman damgasıyla değiştirilemez olarak saklanır.',
  },
  messages: {
    created: 'Üretim emri oluşturuldu.',
    saved: 'Taslak kaydedildi.',
    workflow: 'Durum güncellendi.',
    reserved: 'Mevcut malzeme ayrıldı.',
    posted: 'Malzeme kaydı tamamlandı.',
    stepConfirmed: 'Süreç adımı bildirildi.',
    completed: 'Üretim tamamlandı bildirildi.',
    cancelled: 'Üretim emri iptal edildi.',
    commented: 'Yorum eklendi.',
  },
} as const;
